
import { Component, Vue } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'



@Component({
    name: 'sell',
    components: {},
    filters: {
        formatDate: function (value, type) {
            if (!value) {
                return
            }
            let date = new Date(value * 1000)
            let y = date.getFullYear()
            let MM: any = date.getMonth() + 1
            MM = MM < 10 ? ('0' + MM) : MM
            let d: any = date.getDate()
            d = d < 10 ? ('0' + d) : d
            let h: any = date.getHours()
            let next_h: any = h < 10 ? ('0' + (h + 1)) : (h + 1)
            h = h < 10 ? ('0' + h) : h
            let m: any = date.getMinutes()
            m = m < 10 ? ('0' + m) : m
            let s: any = date.getSeconds()
            s = s < 10 ? ('0' + s) : s
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m
        }
    }

})
export default class extends Vue {
    list: any = []
    time = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30), new Date()]
    problemList: any = [
        { id: 1, name: '增加数据' },
        { id: 3, name: '删除数据' },
        { id: 4, name: '修改数据' }
    ]
    tableData: any = [{
        num: '001',
        date: '2016-05-03',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333
    }]
    tableHeight: number = window.innerHeight - 200
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    employeeList: any = []
    employee: any = []
    problem: any = []
    logesPage: number = 1
    logesSize: number = 20
    start_time: string = ''
    end_time: string = ''
    total_count: number = 1
    pageList: any = []
    table_name: string = ''
    data_name: string = ''
    data_content_name: string = ''

    mounted() {
        this.getHeight()
        this.getSchoolCampus()
        this.getLoges()
    }
    async getSchoolCampus() {
        const res: any = await CourseModule.getSchoolCampus({ types: 'list', org_id: this.org_id })
        if (res.code === 200) {
            this.employeeList = res.data.list
        }
    }
    pageChange(val) {
        this.table_name = val
        this.logesPage = 1
        this.getLoges()
    }
    async getLoges() {
        this.start_time = (Date.parse(<any>this.time[0]) / 1000).toString()
        this.end_time = (Date.parse(<any>this.time[1]) / 1000).toString()
        const problem = this.problem.toString()
        const employee = this.employee.toString()
        const res: any = await CourseModule.logsList({ employee_id: employee, data_id: '', table_name: this.table_name, type: problem, start_time: this.start_time, end_time: this.end_time, page: this.logesPage, size: this.logesSize, data_name: this.data_name, data_content_name:this.data_content_name })
        if (res.code === 200) {
            this.tableData = res.data.list
            this.pageList = res.data.page_name_list
            this.total_count = res.data.total
        }
    }

    problemChange(val) {
        this.problem = val
        this.logesPage = 1
        this.getLoges()
    }
    handleCurrentChange(val) {
        this.logesPage = val
        this.getLoges()
    }
    employeeChange(val) {
        this.employee = val
        this.logesPage = 1
        this.getLoges()
    }
    getHeight() {
        window.onresize = () => {
            this.tableHeight = window.innerHeight - 200
        }
    }
    changeTime(val) {
        const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
        this.time = [val[0], end]
        this.logesPage = 1
        this.getLoges()
    }
    getDataName(val) {
        this.getLoges()
    }
    getDataContentName(val) {
        this.getLoges()
    }
}
